/**
 * Created by Josef Jurca on 03/09/2018.
 */

import {getInstance as getDataSources} from 'datasources';

const ActionTypes = {
        SET_CONNECT_STATE: 'SET_CONNECT_STATE',
        SET_CONNECT_ERROR: 'SET_CONNECT_ERROR'
    },

    ConnectStates = {
        INITIAL: 'INITIAL',
        LOADING: 'LOADING',
        REQUEST_FAILURE: 'REQUEST_FAILURE',
        REQUEST_SUCCESS: 'REQUEST_SUCCESS'
    },

    /**
     * Sets connect code state.
     *
     * @param {string} state - Settings state.
     * @returns {Object} Action object.
     */
    setConnectState = function (state) {

        return {
            type: ActionTypes.SET_CONNECT_STATE,
            state: state
        };
    },

    /**
     * Sets connect code state.
     *
     * @param {string} error - Connect error.
     * @returns {Object} Action object.
     */
    setConnectError = function (error) {

        return {
            type: ActionTypes.SET_CONNECT_ERROR,
            error: error
        };
    },

    /**
     * Retrieves the settings sections from the datasources.
     *
     * @param {string} connectCode - Connect code.
     * @returns {Function} Action function.
     */
    connect = function (connectCode) {
        let dataSources = getDataSources();

        return dispatch => {

            dispatch(setConnectState(ConnectStates.LOADING));

            return dataSources.connectDevice(connectCode)
                .then((response) => {
                    dispatch(setConnectState(ConnectStates.REQUEST_SUCCESS));
                    return Promise.resolve(response);
                })
                .catch((response) => {
                    dispatch(setConnectState(ConnectStates.REQUEST_FAILURE));

                    return Promise.reject(response);
                });
        };
    };

export {
    ActionTypes,
    connect,
    setConnectState,
    setConnectError,
    ConnectStates
};


// WEBPACK FOOTER //
// ./src/js/store/actions/pages/connect.js